import firebase from "firebase"
import "firebase/storage";

var firebaseConfig = {
    apiKey: "AIzaSyCeWFQCpBYOcg1NXW_n0_kMgJkR1JelS54",
    authDomain: "aatmsv4-firebase.firebaseapp.com",
    databaseURL: "https://aatmsv4-firebase.firebaseio.com",
    projectId: "aatmsv4-firebase",
    storageBucket: "gs://aatmsv4-firebase.appspot.com",
    messagingSenderId: "627271314290",
    appId: "1:627271314290:web:d440230b614c23161ccbeb"
};
// Initialize Firebase

export default firebase.initializeApp(firebaseConfig);
export const storage = firebase.storage();
